import React from 'react';
export default function FileStoryInstructions() {
  return /*#__PURE__*/React.createElement("p", {
    style: {
      background: 'lightgray',
      padding: '1em'
    }
  }, "To use these stories you may need to setup", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://bitbucket.org/watermarkinsights/file-upload-server/src/master/"
  }, "file-upload-server"), ". It's pretty easy to get up and running.");
}